import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { useTranslation } from "localization/translation";

const ChangesDetailsModal = ({ text, content, close, isOpen }) => {
  const translation = useTranslation();
  return (
    <Dialog
      classes={{
        paper: `modal-content rounded-lg`,
      }}
      open={isOpen}
      onClose={close}
      aria-labelledby="form-dialog-title"
    >
      <form onSubmit={close}>
        <DialogTitle className="p-4">{text}</DialogTitle>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{translation.name}</TableCell>
              <TableCell>{translation.old_data}</TableCell>
              <TableCell>{translation.new_data}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {content?.map((item) => (
              <TableRow key={item.field}>
                <TableCell>{translation[item.field]}</TableCell>
                <TableCell>{item.oldValue}</TableCell>
                <TableCell>{item.newValue}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <DialogActions className="d-flex mx-auto p-4">
          <Button onClick={close} variant="contained" type="button">
            {translation.close}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ChangesDetailsModal;
